export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10258.93af9b20.jpg";